module.exports = __webpack_public_path__ + "img/whatsaap.865ed7e5.svg";